/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
import React, { useEffect, useRef } from 'react';
import type AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';
import { cx } from '@atlaskit/css';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled';
import type { AnalyticsAttributes } from '@atlassian/analytics-bridge';
import { PanelBody } from '@atlassian/panel-system';
import { PreviewPanelSniffer } from './preview-panel-sniffer';
const panelSystemStyles = {
  fillParent: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
interface PreviewPanelBodyProps {
  analyticsAttributes?: AnalyticsAttributes;
  analyticsClient?: AnalyticsWebClient | undefined | null;
  children: React.ReactNode;
  panelType?: string;
  parentProduct?: string;
  styles?: Record<string, any>;
}
export const PreviewPanelBody = ({
  children,
  analyticsClient,
  parentProduct,
  panelType,
  analyticsAttributes,
  styles: consumerStyles
}: PreviewPanelBodyProps): React.JSX.Element => {
  const bodyRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (analyticsClient) {
      analyticsClient.sendTrackEvent({
        action: 'viewed',
        actionSubject: 'preview-panel',
        actionSubjectId: 'preview-panel-view',
        source: 'preview-panel',
        attributes: {
          parentProduct,
          panelType,
          // Availability check only — this decides whether to decorate the preview-panel
          // "viewed" track event with analyticsAttributes, NOT whether the user is
          // accessing the Capacity planning experience. We therefore read the GA
          // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
          // exposure is fired at the point the user actually opens the Capacity
          // experience, keeping the GA experiment's population clean.
          //
          // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
          // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
          // experiment is never read at all. EAP customers remain unconditionally enabled.
          ...(fg('add_capacity_tab_to_the_board_horizontal_nav') || fg('add-trigger-point-key-attribute-to-preview-panel') || FeatureGates.getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
          }) ? analyticsAttributes : {})
        }
      });
      // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
      // Fires at most once per hour, per product.
      // Requires tenantInfo and userInfo to be set
      analyticsClient?.startUIViewedEvent();
    }
  }, [analyticsClient, parentProduct, panelType, analyticsAttributes]);

  // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
  /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */
  const panelBodyContent = fg('ads-panel-system-gpp') ? <Box xcss={cx(panelSystemStyles.fillParent, !!consumerStyles && consumerStyles)} ref={bodyRef}>
			{children}
		</Box> : <Box xcss={cx(!!consumerStyles && consumerStyles)} ref={bodyRef}>
			{children}
		</Box>;
  /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */

  if (fg('ads-panel-system-gpp')) {
    const wrappedBody = <PanelBody spacing="none">{panelBodyContent}</PanelBody>;
    return <PreviewPanelSniffer containerRef={bodyRef} analyticsClient={analyticsClient} parentProduct={parentProduct} panelType={panelType} analyticsAttributes={analyticsAttributes}>
				{wrappedBody}
			</PreviewPanelSniffer>;
  }
  return <PreviewPanelSniffer containerRef={bodyRef} analyticsClient={analyticsClient} parentProduct={parentProduct} panelType={panelType} analyticsAttributes={analyticsAttributes}>
			{panelBodyContent}
		</PreviewPanelSniffer>;
};